<template>
    <figure class="z-figure">
        <div
            v-if="!video"
            :class="[
                'z-figure__image',
                {'z-figure--border-radius': borderRadius}
            ]"
            :style="`background-image: url(${image}); padding-top: ${paddingTop}`"

        ></div>

        <div
            :class="[
                { 'z-figure__video' : video },
                { 'z-figure--border-radius': borderRadius }
            ]"
            v-if="video"
        >
            <z-video
                :src="video"
                :poster="image"
                :autoplay="false"
            ></z-video>
        </div>

        <figcaption
            class="z-figure__caption"
            :class="`u-text-align-${captionAlignText}`"
            v-if="caption"
            v-html="caption"
        ></figcaption>
    </figure>
</template>


<script setup>
const props = defineProps({
    image: {
        type: String
    },
    caption: {
        type: String
    },
    paddingTop: {
        type: String
    },
    borderRadius: {
        type: Boolean,
        default: false
    },
    video: {
        type: [String, Array]
    },
    captionAlignText: {
        type: String,
        default: 'left',
        validator: prop => ['left', 'right', 'center'].includes(prop)
    }
})

defineExpose({
    props
})
</script>

<style lang="scss" src="./index.scss"></style>
